<shared-circle-counter class="tile-for-loyalty-program-product-counter" [size]="size" [current]="currCount"
    [total]="maxCount">
    <ng-container *ngIf="programItem && !programItem?.isLoading">

        <img [url]="pathToImages + iconActive" directive-image-preload alt=""
            class="tile-for-loyalty-program-product-counter__img" />

        <div class="tile-for-loyalty-program-product-counter__hd">{{programItem?.program?.ProgramName}}</div>


        <shared-x-of-counter class="tile-for-loyalty-program-product-counter__counter"
            *ngIf="programItem && !programItem?.isLoading" [current]="currCount" [of]="maxCount">
        </shared-x-of-counter>
    </ng-container>

    <shared-loader-for-spinner *ngIf="!programItem || programItem?.isLoading"
        class="tile-for-loyalty-program-product-counter__loader"></shared-loader-for-spinner>
</shared-circle-counter>